module.exports = __webpack_public_path__ + "img/day15.bf6d706b.svg";